import React, { FC } from 'react'

import Title from '@models/Title'

interface Props {
  title: Title | null
}

const Embed: FC<Props> = ({ title }) => {
  if (!title) return null
  return (
    <section className="max-w-[870px] aspect-[21/29] w-full border border-gray dark:border-gray-border-dm shadow-thick bg-white mx-4">
      <iframe
        title={title?.title}
        width="100%"
        height="100%"
        src={title?.embed_url}
        allow="camera *;microphone *;autoplay"
        id="embed_score"
        allowFullScreen></iframe>
    </section>
  )
}

export default Embed
